import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import dialogPolyfill from 'dialog-polyfill';
import { ConsentService } from '../services/consentService';
import { ConsentState } from '../services/consentState';

export class CookieConsentComponent {
  private static cookieConsentComponentInstance: CookieConsentComponent;
  private static readonly openerSelector: string = '[data-js-cookie-consent-opener]';
  private static readonly dialogSelector: string = '[data-js-cookie-consent-dialog]';
  private static readonly setAllConsentButtonSelector: string = '[data-js-set-all-consent]';
  private static readonly setEssentialConsentButtonSelector: string = '[data-js-set-essential-consent]';

  private readonly consentService: ConsentService;

  private static get dialog(): HTMLDialogElement {
    return document.querySelector(CookieConsentComponent.dialogSelector) || null;
  }

  public static get instance(): CookieConsentComponent {
    if (!CookieConsentComponent.cookieConsentComponentInstance) {
      CookieConsentComponent.cookieConsentComponentInstance = new CookieConsentComponent();
    }

    return CookieConsentComponent.cookieConsentComponentInstance;
  }

  protected constructor() {
    this.consentService = ConsentService.instance;
  }

  private static openConsentDialog(event?: MouseEvent) {
    event?.preventDefault();

    const { dialog } = CookieConsentComponent;

    if (!dialog) {
      return;
    }

    dialogPolyfill.registerDialog(dialog);

    if (dialog.hasAttribute('onclose') && !dialog.onclose) {
      dialog.setAttribute('ontoggle', dialog.getAttribute('onclose'));
      dialog.onclose = dialog.ontoggle;
      dialog.removeAttribute('ontoggle');
    }

    disableBodyScroll(dialog, { reserveScrollBarGap: true });
    dialog.showModal();
  }

  public init() {
    window.addEventListener('load', () => {
      this.setupEvents();
      this.checkConsent();
    });
  }

  private checkConsent() {
    const { consentIsSet } = this.consentService;

    if (!consentIsSet) {
       //CookieConsentComponent.openConsentDialog();
    }
  }

  private setAllConsent(): void {
    const { dialog } = CookieConsentComponent;

    this.consentService.consentStates = [ConsentState.ESSENTIAL, ConsentState.FUNCTIONAL, ConsentState.ANALYTICS, ConsentState.ADVERTISING];
    dialog.close();
    enableBodyScroll(dialog);
  }

  private setEssentialConsent(): void {
    const { dialog } = CookieConsentComponent;

    this.consentService.consentsForSession = [ConsentState.ESSENTIAL];
    dialog.close();
    enableBodyScroll(dialog);
  }

  private setupEvents(): void {
    const { openerSelector, dialog, setAllConsentButtonSelector, setEssentialConsentButtonSelector } = CookieConsentComponent;

    if (!dialog) {
      return;
    }

    document.querySelectorAll(openerSelector).forEach((opener) =>
      opener.addEventListener('click', CookieConsentComponent.openConsentDialog)
    );

    dialog.querySelector(setAllConsentButtonSelector).addEventListener('click', this.setAllConsent.bind(this));
    dialog.querySelector(setEssentialConsentButtonSelector).addEventListener('click', this.setEssentialConsent.bind(this));
    dialog.addEventListener('cancel', (event) => { event.preventDefault() });
  }
}
